"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.438 6.6H8.563c-.557 0-.763.228-.763.845v7.453c0 .07.003.135.008.195.012.135.015.266.128.414.011.014.127.11.127.11.062.034.104.059.175.09l3.385 1.571c.176.09.249.125.377.122.128.003.202-.032.377-.122l3.385-1.57c.07-.032.113-.057.175-.09 0 0 .116-.097.127-.11.113-.15.116-.28.128-.415.006-.06.008-.125.008-.195V7.445c0-.617-.205-.845-.762-.845z" }), "Logo");
//# sourceMappingURL=Logo.js.map